import { PureComponent } from 'react';

import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import { formatRelativeDate } from '../utils/format-relative-date';
import { differenceInDays, getNonFuture, localeFormat } from '../utils/time';

import ISODate, { ISODateString } from './iso-date';

type RelativeDateProps = {
  date: Date | string;
  intl: IntlShape;
};

class RelativeDate extends PureComponent<RelativeDateProps> {
  render() {
    const { intl } = this.props;

    const date = getNonFuture(this.props.date);

    return differenceInDays(date) > 7 ? (
      <ISODate date={date} />
    ) : (
      <span title={intl.formatDate(date, localeFormat)}>
        {formatRelativeDate(date.getTime(), intl)}
      </span>
    );
  }
}
// eslint-disable-next-line import/no-default-export
export default injectIntl(RelativeDate);

export function relativeDateString(
  date: Date | string | null,
  intl: IntlShape
): string {
  if (!date) {
    return '';
  }

  const adjustedDate = getNonFuture(date);

  return differenceInDays(adjustedDate) > 7
    ? ISODateString(adjustedDate)
    : formatRelativeDate(adjustedDate.getTime(), intl);
}
